import "./journal-search/jquery.min.js";

import {saveAs} from 'file-saver';
import {stringify} from 'csv-stringify/browser/esm/sync';

import {html} from './journal-search/html.js';
import {raftCounts} from './journal-search/raft-counts.js';
import './journal-search/journal-search.scss';

const journalSearchEl = document.querySelector('.rilm-journal-search');

function journalSearch(options)
{
    if (!options) options = {};
    const self = this;

    this.apiLink = "https://api.rilm.org/ibis/200/journal";

    const abstracts = this.abstracts = options.abstracts || journalSearchEl.getAttribute('data-abstracts') === 'true';
    const snapshot = this.snapshot = options.snapshot || journalSearchEl.getAttribute('data-snapshot') === 'true';
    const fulltext = this.fulltext = options.fulltext || journalSearchEl.getAttribute('data-fulltext') === 'true';
    const musicExcelLink = journalSearchEl.getAttribute('data-music-excel');
    const nonMusicExcelLink = journalSearchEl.getAttribute('data-non-music-excel');


    this.loadCountries = options.loadCountries || true;
    this.loadLangs = options.loadLangs || true;

    this.thisYear = (new Date()).getFullYear();
    this.alreadyLoaded = [];

    journalSearchEl.innerHTML = html({
        abstracts,
        snapshot,
        fulltext,
        musicExcelLink,
        nonMusicExcelLink,
        title: this.fulltext || this.snapshot ? 'RILM Abstracts of Music Literature (with Full Text)'
            : 'RILM Abstracts of Music Literature'
    });

    this.resultsTable = options.resultsTable || document.getElementById("resultsTable");
    this.resultsDiag = options.resultsDiag || document.getElementById("resultsDiag");
    this.searchInputSelector = options.searchInputSelector || ".journalsearch-input";
    this.searchType = options.searchType || document.getElementById("journalsearch-type")
    this.searchExecuteSelector = options.searchExecuteSelector || ".journal-search-execute";
    this.conciseDownloadSelector = options.conciseDownloadSelector || ".journal-search-concise";
    this.searchBoolSelector = options.searchBoolSelector || ".journalsearch-bool";
    this.postSearchFilter = options.postSearchFilter;

    this.ensureValue = function(obj, which)
    {
        if (!obj[which]) return "";
        if (obj[which] === '0000-0000') return "";
        if (obj[which].trim() === '') return "";
        return which + ": " + obj[which] + "<br/>";
    };

    function formatCoverage(obj) {
        if (obj.ftStart && obj.ftEnd) {
            return "Coverage: " + obj.ftStart.toString().trim().replace("-", "/") + "–" +
                obj.ftEnd.toString().trim().replace("-", "/");
        }

        return "Full-text content coming soon!";
    }

    // Handler for each distinct object to display on the page
    this.formatObj = function(dataIn, params)
    {
        var subtitle = "";
        if (params.fulltext)
        {
            subtitle = formatCoverage(dataIn);
        }
        else
        {
            var aliases = [];
            var defaultName = dataIn.defaultName;
            for (var hIdx = 0; hIdx < dataIn.history.length; hIdx++)
            {
                var thisName = dataIn.history[hIdx].name;
                if ((thisName !== defaultName) && (aliases.indexOf(thisName) === -1))
                    aliases.push(thisName);
            }

            if (aliases.length > 0) aliases.unshift("<b>Also published as:</b>");
            subtitle = aliases.join("<br/>");
        }

        var TID = dataIn.TID;
        var JID = dataIn.JID;
        var uniqueID = TID ? "t" + TID : "j" + JID;
        var retString = "<li id='" + uniqueID + "' " + (TID ? " data-tid='" + TID + "'" : " data-jid='" + JID + "'") + ">" +
            "<h2 class='ft-check'>" +
                "<div class='journal-title'>" +
                    "<div class='journal-name'>" + dataIn.defaultName.replace(/</g, "").replace(/>/g, "") + "</div>" +
                    "<div class='preview-sub'>" + subtitle + "</div>" +
                "</div>" +
                "<i class='toggle fa fa-chevron-down'></i></h2>"; // preview bit

        if (params.fulltext)
        {
            retString += `<div class='tid-body content-append'>
                    <div class='tid-images'>`; // images

            if (!raftCounts[TID])
                retString += "<span class='image-replacement hidden'>No preview images available for this journal.</span>";
            else
            {
                for (let iIdx = 0; iIdx < raftCounts[TID]; iIdx++)
                {
                    retString += `<img onError='handleImageError(this)' class='ft-img'
                        data-src='/wp-content/themes/rilm/images/fulltext/${TID}/${TID}-${iIdx}.png'/>`;
                }
            }

            retString += `</div>
                <div class='tid-text'>
                    <p class='tid-blurb'>${dataIn.blurb || ''}</p>
                </div>
            </div>`;
        }
        else
        {
            retString += '<div class="content-append"></div>'
        }

        return retString + "</li>";
    };

    this.postSearchFilter = function(data, params)
    {
        var filteredData = {};
        for (var idx = 0; idx < data.length; idx++)
        {
            var dataObj = data[idx];
            var uniqueID = dataObj.TID ? "t" + dataObj.TID : "j" + dataObj.JID;
            var filteredObj = filteredData[uniqueID];

            if (filteredObj)
            {
                // If we're working with fulltext, make sure ftStart/ftEnd/defaultName are set
                if (params.fulltext)
                {
                    // if there's an ftStart object and the current one is Infinity or it's less than the current one
                    if (dataObj.ftStart != null && ((parseInt(dataObj.ftStart) < parseInt(filteredObj.ftStart)) || (filteredObj.ftStart === Infinity)))
                        filteredObj.ftStart = dataObj.ftStart;
                    if (parseInt(dataObj.ftEnd) > parseInt(filteredObj.ftEnd))
                    {
                        filteredObj.ftEnd = dataObj.ftEnd;
                        filteredObj.defaultName = dataObj.name;
                        filteredObj.nameSort = dataObj.nameSort || filteredObj.nameSort;
                    }
                }
                // Otherwise, defaultName/nameSort should be the one that matches the query
                else if (params.name)
                {
                    var oldMatch = filteredObj.defaultName.match(new RegExp(params.name, "i"));
                    var thisMatch = dataObj.name.match(new RegExp(params.name, "i"));

                    if (!oldMatch && thisMatch)
                    {
                        filteredObj.defaultName = dataObj.name;
                        filteredObj.nameSort = dataObj.nameSort || filteredObj.nameSort;
                    }
                }
            }
            else if(!dataObj.name) continue;
            else
            {
                filteredObj = filteredData[uniqueID] = {
                    'TID': dataObj.TID,
                    'JID': dataObj.JID,
                    'defaultName': dataObj.name,
                    'nameSort': dataObj.nameSort,
                    'ftStart': dataObj.ftStart || Infinity,
                    'ftEnd': dataObj.ftEnd || 0,
                    'history': []
                };
            }

            // if there's a blurb with this one, and either this is preferred or we haven't set it yet
            if (dataObj.blurb && (!filteredObj.blurb || dataObj.preferred))
                filteredObj.blurb = dataObj.blurb;

            if (dataObj.name)
            {
                var toPush = {
                    'JID': dataObj.JID,
                    'name': dataObj.name
                };

                filteredObj.history.push(toPush);
            }
        }

        // Make everything sortable and sort it
        var dataArr = [];
        for (var uniqueID in filteredData)
        {
            if (filteredData[uniqueID].nameSort) filteredData[uniqueID].nameSort = filteredData[uniqueID].nameSort.replace('É', 'E').replace("Ü", "U");
            dataArr.push({'uniqueID': uniqueID, 'nameSort': filteredData[uniqueID].nameSort || filteredData[uniqueID].defaultName});
        }

        dataArr = dataArr.sort(function(a, b)
        {
            var lowerA = a.nameSort.trim().toLowerCase();
            var lowerB = b.nameSort.trim().toLowerCase();
            if (lowerA === lowerB) return 0;
            if (lowerA > lowerB) return 1;
            if (lowerB > lowerA) return -1;
        });

        var retArr = [];
        for (var dIdx = 0; dIdx < dataArr.length; dIdx++)
            retArr.push(filteredData[dataArr[dIdx].uniqueID]);

        return retArr;
    };

    this.triggerSubload = function(el)
    {
        // Just show it if we've already loaded it
        var id = el.getAttribute('id');
        if (this.alreadyLoaded.indexOf(id) > -1) return this.subloadCleanup(el);
        this.alreadyLoaded.push(id);

        // Else prep the URL to call
        var tid = el.getAttribute("data-tid");
        var jid = el.getAttribute("data-jid");
        var url = this.apiLink + "/journal?fulltext=" + this.fulltext;
        if (tid) url += "&tid=" + tid;
        else url += "&jid=" + jid;
        $.ajax({
            'method': 'GET',
            'contentType': 'application/json',
            'url': url,
            'success': function (data) {
                el.classList.remove("loading");

                var historyObj = [];
                for (var idx = 0; idx < data.length; idx++)
                {
                    var dataObj = data[idx];

                    var nameFound = false;
                    for (var hIdx = 0; hIdx < historyObj.length; hIdx++)
                    {
                        var histObj = historyObj[hIdx];
                        if (histObj.name === dataObj.name && histObj.pubName === dataObj.pubName && histObj.ISSN === dataObj.ISSN)
                        {
                            if (dataObj.ftStart) histObj.ftStart = Math.min(parseInt(histObj.ftStart), parseInt(dataObj.ftStart));
                            if (dataObj.ftEnd) histObj.ftEnd = Math.max(parseInt(histObj.ftEnd), parseInt(dataObj.ftEnd));
                            if (dataObj.idxStart) histObj.idxStart = Math.min(parseInt(histObj.idxStart), parseInt(dataObj.idxStart));
                            if (dataObj.idxEnd) histObj.idxEnd = Math.max(parseInt(histObj.idxEnd), parseInt(dataObj.idxEnd));
                            nameFound = true;
                            break;
                        }
                    }

                    var intIdxEnd = parseInt(dataObj['idxEnd']);
                    if (dataObj.embargo_months)
                    {
                        if (intIdxEnd < ((new Date()).getFullYear() - Math.ceil(dataObj.embargo_months / 12)))
                            dataObj.embargo_months = "";
                    }

                    if (!nameFound && dataObj.name)
                    {
                        var languages = [];
                        for (var lIdx = 0; lIdx < dataObj.langs.length; lIdx++)
                            if (self.langs[dataObj.langs[lIdx]])
                                languages.push(self.langs[dataObj.langs[lIdx]]);

                        var countries = [];
                        for (var cIdx = 0; cIdx < dataObj.countries.length; cIdx++)
                            if (self.countries[dataObj.countries[cIdx]])
                                countries.push(self.countries[dataObj.countries[cIdx]]);

                        var toPush = {
                            'JID': dataObj.JID,
                            'name': dataObj.name,
                            'ISSN': dataObj.ISSN,
                            'EISSN': dataObj.EISSN,
                            'CODEN': dataObj.CODEN,
                            'pubName': dataObj.pubName,
                            'CC': countries,
                            'languages': languages,
                            'ftStart': dataObj.ftStart,
                            'ftEnd': dataObj.ftEnd,
                            'idxStart': dataObj.idxStart,
                            'idxEnd': dataObj.idxEnd,
                            'maxYR': dataObj.maxYR && dataObj.maxYR.indexOf("-") > -1 ? "(" + dataObj.maxYR + ")" : dataObj.maxYR,
                            'minYR': dataObj.minYR && dataObj.minYR.indexOf("-") > -1 ? "(" + dataObj.minYR + ")" : dataObj.minYR,
                            'intIdxStart': parseInt(dataObj.idxStart),
                            'intIdxEnd': intIdxEnd,
                            'embargo_months': dataObj.embargo_months,
                            'priority': dataObj.priority,
                            'fulltextJID': dataObj.fulltextJID
                        };

                        historyObj.push(toPush);
                    }
                }

                // sort history in correct order
                historyObj.sort(function(a, b)
                {
                    return parseInt(a.intIdxEnd) < parseInt(b.intIdxEnd);
                });

                var jidString = "";
                var multiJID = historyObj.length > 1;
                for (var hIdx = 0; hIdx < historyObj.length; hIdx++)
                {
                    var histObj = historyObj[hIdx];
                    jidString += "<div id='jid-" + histObj.JID + "' class='jid tid-jid accord-hidden'>" +
                        (multiJID ? "Published as: <b>" + histObj.name + "</b><br/>" : "") +
                        (histObj.pubName ? "Published by: " + histObj.pubName + "<br/>" : "") +
                        (histObj.priority ? "Priority: " + priorities[histObj.priority] + "<br/>" : "") +
                        (histObj.CC ? "Country: " + histObj.CC.join(", ") + "<br/>" : "") +
                        (histObj.languages.length > 0 ? "Language: " + histObj.languages.join(", ") + "<br/>" : "") +
                        (self.fulltext && histObj.idxStart ? "Published date: " + histObj.idxStart.toString().trim().replace("-", "/") + "–" + (histObj.idxEnd || self.thisYear).toString().trim().replace("-", "/") + "<br/>" : "") +

                        // Coverage - if fulltext, use ftStart/ftEnd, else use minYR/maxYR
                        (self.fulltext && (multiJID) && histObj.ftStart && histObj.ftEnd ? "Coverage: " + histObj.ftStart.toString().trim().replace("-", "/") + "–" + histObj.ftEnd.toString().trim().replace("-", "/") + "<br/>" : "") +
                        (!self.fulltext && histObj.maxYR ? "Coverage: " + histObj.minYR + "–" + histObj.maxYR + "<br/>" : "") +
                        (histObj.embargo_months ? "Moving wall: " + histObj.embargo_months + " months<br/>" : "") +
                        ((histObj.fulltextJID && !this.fulltext) ? "Contains fulltext records in RAFT.<br/>" : "") +
                        self.ensureValue(histObj, "ISSN") +
                        self.ensureValue(histObj, "EISSN") +
                        self.ensureValue(histObj, "CODEN") +
                        "</div>";
                }

                el.querySelector('.content-append').innerHTML += jidString;
                self.subloadCleanup(el)
            },
            'error': function() {
                self.resultsDiag.innerHTML = "The server encountered an error with that search. Please try again later."
            }
        });
    }

    this.subloadCleanup = function(el)
    {
        if (self.fulltext)
        {
            var images = el.querySelectorAll("img");
            for (var iIdx = 0; iIdx < images.length; iIdx++)
            {
                images[iIdx].setAttribute('src', images[iIdx].getAttribute('data-src'));
            }

            $(images[0]).hide().fadeIn();
            resetInterval(el.getAttribute('id'));
        }

        // Because I can't figure out why this isn't working
        // self.resetAccordListeners(); Not sure what the original problem was, but at some point this started causing duplicate loading of the publication info, and removing it solved the issue. --EM
    }

    this.handleSearch = function(e)
    {
        var payload = [];
        var urlObj = {};

        // From the search type dropdown
        if (e.target.classList.contains("journal-from-type"))
        {
            var searchTypeVal = this.searchType.value;
            var searchValue = document.querySelector(this.searchInputSelector + "[data-target='" + searchTypeVal + "']").value;

            if (!searchValue || searchValue.startsWith('Search full-text journals'))
            {
                this.resultsDiag.innerHTML = "Please select a search value.";
                return;
            }

            payload.push({
                'query': searchTypeVal,
                'value': searchValue
            });
            urlObj[searchTypeVal] = searchValue;
        }

        // From the priority letters
        if (e.target.classList.contains("journal-letter"))
        {
            var value = e.target.getAttribute('data-value');
            if (value !== 'all')
            {
                payload.push({
                    'query': 'nameStart',
                    'value': value
                });
                urlObj.name = "^" + value; // for regex match
            }
        }

        // loadall for fulltext, nothing needed

        // priority qualifier
        if (e.target.classList.contains('journal-priority-restricted'))
        {
            payload.push({
                'query': 'priority',
                'value': [1, 2]
            });
            urlObj.priority = true;
        }

        // fulltext qualifier
        if (self.fulltext)
        {
            urlObj.fulltext = true;
        }

        var bools = document.querySelectorAll(options.searchBoolSelector);
        for (var bIdx = 0; bIdx < bools.length; bIdx++)
        {
            var bool = bools[bIdx];
            if (bool.checked)
                payload.push({
                    'query': bool.getAttribute('data-target'),
                    'level': 'bool'
                });
        }

        this.resetTableForSearch();

        payload = {
            fulltext: self.fulltext,
            filters: payload
        };

        $.ajax({
            'method': 'POST',
            'data': JSON.stringify(payload),
            'contentType': 'application/json',
            'url': this.apiLink + "/journal_list",
            'success': function (data) {
                if (data.length === 0)
                    self.resultsDiag.innerHTML = "No results could be found.";
                else
                {
                    self.resultsDiag.innerHTML = "Formatting...";

                    // Use a filter for the data
                    var filteredData = self.postSearchFilter(data, urlObj);

                    var htmlString = "";
                    for (var dIdx = 0; dIdx < filteredData.length; dIdx++)
                        htmlString += self.formatObj(filteredData[dIdx], urlObj);
                    self.resultsTable.innerHTML = htmlString;

                    self.resetAccordListeners();
                    self.resultsDiag.innerHTML = "";
                }
            },
            'error': function() {
                self.resultsDiag.innerHTML = "The server encountered an error with that search. Please try again later."
            }
        });
    };

    this.handleConcise = function(e)
    {
        // Because a spinner is too annoying to implement
        e.currentTarget.textContent = 'Downloading concise list...';

        // Mimic params from above
        const urlObj = {fulltext: self.fulltext};
        const payload = {
            fulltext: self.fulltext,
            filters: []
        };

        let rows, XLSX;
        let promises = [
            new Promise((resolve, reject) => {
                import('xlsx/xlsx.mjs').then((a) => {
                    XLSX = a;
                    resolve();
                })
            }),
            new Promise((resolve, reject) => {
                $.ajax({
                    'method': 'POST',
                    'data': JSON.stringify(payload),
                    'contentType': 'application/json',
                    'url': this.apiLink + "/journal_list",
                    'success': function (data) {
                        const filteredData = self.postSearchFilter(data, urlObj);

                        rows = filteredData.map(obj => [obj.defaultName, formatCoverage(obj)]);
                        resolve();
                    },
                    'error': function() {
                        self.resultsDiag.innerHTML = "The server encountered an error with that search. Please try again later."
                    }
                });
            })
        ];

        // For some reason, using `async function` anywhere in here causes a shit fit, so...
        Promise.all(promises).then(() =>
        {
            const date = new Date().toLocaleDateString().replace(/\//g, '-');;

            // generate worksheet and workbook
            const worksheet = XLSX.utils.aoa_to_sheet(rows);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, `RILM RAFT Journals (${date})`);

            // prepend headers
            XLSX.utils.sheet_add_aoa(worksheet, [["Name", "Coverage"]], { origin: "A1" });

            // Calculate column width - stolen from example
            const max_width = rows.reduce((w, r) => Math.max(w, r[0].length), 10);
            worksheet["!cols"] = [ { wch: max_width } ];

            /* create an XLSX file and try to save to Presidents.xlsx */
            XLSX.writeFile(workbook, `RILM-RAFT-journal-export-${date}.xlsx`);
            // const blob = new Blob([rows], {type: "text/csv;charset=utf-8"});
            // saveAs(blob, `RILM-RAFT-journal-export-${date}.csv`);

            // Reset text
            e.currentTarget.textContent = 'Download concise list...';
        });
    };

    this.handleKeypressSearch = function(e)
    {
        if (e.keyCode === 13 || e.which === 13)
        {
            $(e.target.parentNode.querySelector(this.searchExecuteSelector)).trigger('click');
        }
    };

    this.resetTableForSearch = function()
    {
        this.resultsDiag.innerHTML = "Loading...";
        this.resultsTable.innerHTML = "";
    };

    this.resetAccordListeners = function()
    {
        this.alreadyLoaded = [];
        $(".ft-check").off(".toggleListener");
        $(".ft-check").on("click.toggleListener", function(e)
        {
            const rootNode = e.target.closest("li");
            rootNode.classList.toggle('opened');
            if (rootNode.classList.contains('opened')) self.triggerSubload(rootNode);

            const toggle = rootNode.querySelector('i.toggle');
            toggle.classList.toggle('fa-chevron-up');
            toggle.classList.toggle('fa-chevron-down');
        });
    };

    /**
     * Initialization code
     */

    // Listeners
    $(this.searchExecuteSelector).on("click", this.handleSearch.bind(this));
    $(this.searchInputSelector).on("keypress", this.handleKeypressSearch.bind(this));

    const cdsEl = document.querySelector(this.conciseDownloadSelector);
    if (cdsEl) {
        cdsEl.addEventListener("click", this.handleConcise.bind(this));
    }

    $(this.searchType).on("change", function(e)
    {
        var target = e.target.value;
        $(self.searchInputSelector).addClass("hidden");
        document.querySelector(".journalsearch-input[data-target='" + target + "']").classList.remove("hidden");
    });

    // Populate enums from the API
    var countries = this.countries = {};
    if (this.loadCountries)
    {
        $.ajax({
            'url': this.apiLink + "/country" + (self.fulltext ? '?fulltext=true' : ''),
            'success': function (data) {
                var countryObj = document.querySelector(self.searchInputSelector + "[data-target='CC']");
                var optString = "<option>Search " + (self.fulltext ? "full-text" : "all") + " journals by country</option>";

                for (var cIdx = 0; cIdx < data.length; cIdx++)
                {
                    var country = data[cIdx];
                    countries[country.id] = country.name;
                    optString += "<option value='" + country.id + "'>" + country.name + "</option>";
                }

                countryObj.innerHTML = optString;
            }
        });
    }

    var langs = this.langs = {};
    if (this.loadLangs)
    {
        $.ajax({
            'url': this.apiLink + "/language" + (self.fulltext ? '?fulltext=true' : ''),
            'success': function (data) {
                var langObj = document.querySelector(self.searchInputSelector + "[data-target='language']");
                var optString = "<option>Search " + (self.fulltext ? "full-text" : "all") + " journals by language</option>";

                for (var lIdx = 0; lIdx < data.length; lIdx++)
                {
                    var language = data[lIdx];
                    langs[language.id] = language.lang;
                    optString += "<option value='" + language.id + "'>" + language.lang + "</option>";
                }

                langObj.innerHTML = optString;
            }
        });
    }

    var priorities = {};
    $.ajax({
        'url': this.apiLink + "/priority",
        'success': function (data) {
            var priorityObj = document.querySelector(self.searchInputSelector + "[data-target='priority']");
            var optString = "<option>Search " + (self.fulltext ? "full-text" : "all") + " journals by priority</option>";

            for (var pIdx = 0; pIdx < data.length; pIdx++)
            {
                var priority = data[pIdx];
                priorities[priority.id] = priority.name;
                optString += "<option value='" + priority.id + "'>" + priority.name + "</option>";
            }

            priorityObj.innerHTML = optString;
        }
    });
};

window.formCheck = function()
{
    var fromVal = document.forms["form"].from.value;
    var toVal = document.forms["form"].to.value;

    var debugEl = document.getElementById("form-debug");
    if (isNaN(parseInt(fromVal)))
    {
      debugEl.textContent = "Please put a year in the 'Start' field.";
      return false;
    }
    if (isNaN(parseInt(toVal)))
    {
      debugEl.textContent = "Please put a year in the 'End' field.";
      return false;
    }
    if (parseInt(toVal) < parseInt(fromVal))
    {
      debugEl.textContent = "Please make sure the 'Start' year is before the 'End' year.";
      return false;
    }
    return true;
}

const fadeIntervals = {};
function resetInterval(ID)
{
    // if the element has been removed (new search, likely)
    if (!document.getElementById(ID))
        return window.clearInterval(fadeIntervals[ID]);

    if (document.getElementById(ID).querySelectorAll(".ft-img").length < 2)
    {
        $(document.getElementById(ID).querySelectorAll(".ft-img")).show().removeClass("hidden");
        return;
    }

    if (fadeIntervals[ID])
        window.clearInterval(fadeIntervals[ID]);
    fadeIntervals[ID] = window.setInterval(function()
    {
        var visibles = document.getElementById(ID).querySelectorAll(".ft-img[src]:not(.hidden)");
        var target = $(visibles[0].nextSibling || visibles[0].parentNode.childNodes[0]);
        var visible = $(visibles[0]);

        visible.show().fadeOut({
            'duration': 1000,
            'complete': function()
            {
                target.hide().fadeIn();
            }
        });

        visible.addClass("hidden");
        target.removeClass("hidden");
    }, 9000);
}

// Tracks image errors/rotations
function handleImageError (target)
{
    var span = document.createElement("span");
    span.className = "ft-img image-replacement" + (target.className.indexOf("hidden") > -1 ? " hidden" : "");
    span.setAttribute('src', ''); // don't asl
    span.textContent = "Journal preview image failed to load.";
    target.parentNode.appendChild(span);
    target.parentNode.removeChild(target);
}

new journalSearch();
